import React, { useState, useContext, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Typography, TableSortLabel } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContextProvider';
import { Link } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import '../App.css';

const GroupList = () => {
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [order, setOrder] = useState('asc');
  const [orderBy] = useState('name');
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchUsers = async () => {
      const params = {
        _site: user._site._id,
      };
      rpc({
        method: "GetUsers",
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: setUsers
      });
    };

    const fetchGroups = async () => {
      const params = {
        _site: user._site._id,
      };
      rpc({
        method: "GetEventGroups",
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: setGroups
      });
    };
    fetchUsers();
    fetchGroups();
  }, [user]);
  
  const createGroup = () => {
    navigate('/createGroup');
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const handleRequestSort = () => {
    const isAsc = orderBy === 'name' && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setGroups([...groups].sort((a, b) => (isAsc ? b.name.localeCompare(a.name) : a.name.localeCompare(b.name))));
  };

  const getUsersInGroup = (group) => {
    let usersInGroup = [];
    users.forEach(user => {
      user._eventGroups.forEach(eventGroup => {
        if (eventGroup._id === group._id) {
          usersInGroup.push(`${user.first} ${user.last}`);
        }
      });
    });
    return usersInGroup.join(', ');
  };

  return (
    <div className="GroupList">
      <Typography variant="h6" gutterBottom>
        Event Groups
      </Typography>
      <TableContainer className="TableContainer" component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === 'name'}
                  direction={orderBy === 'name' ? order : 'asc'}
                  onClick={handleRequestSort}
                >
                  <b>Name</b>
                </TableSortLabel>
              </TableCell>
              <TableCell><b>Display Name</b></TableCell>
              <TableCell><b>Description</b></TableCell>
              <TableCell><b>Users</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groups.map((group, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Link to={`/group/${group._id}`}>{group.name}</Link>
                </TableCell>
                <TableCell>{group.displayName}</TableCell>
                <TableCell>{group.description}</TableCell>
                <TableCell>{getUsersInGroup(group)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button className="Button" variant="contained" color="primary" onClick={createGroup}>
        Create
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default GroupList;
